import {RootState} from '../../store';
import {Registration} from './types';

export const selectionSelector = (state: RootState): Record<string, Registration> =>
    state['registrations'].selection;
